import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ServicesOverviewComponent } from './services-overview/services-overview.component';
import { StubsDataComponent } from './stubs-data-add/stubs-data-add.component';
// import { StubsDataEditComponent } from './stubs-data-edit/stubs-data-edit.component';
import { StubsOverviewComponent } from './stubs-overview/stubs-overview.component';
import { ServiceDetailsComponent } from './service-details/service-details.component';
import { TemplateDetailsComponent } from './template-details/template-details.component';

const routes: Routes = [
  {
    path: '',
    component: ServicesOverviewComponent
  },
  {
    path: 'stubsdata/:serviceName/:id',
    component: StubsDataComponent
  },
  {
    path: 'stubsdata/:serviceName',
    component: StubsDataComponent
  },
  {
    path: 'stubsoverview/:id',
    component: StubsOverviewComponent
  },
  {
    path: 'servicedetails',
    component: ServiceDetailsComponent
  },
  {
    path: 'servicedetails/:serviceName',
    component: ServiceDetailsComponent
  },
  {
    path: 'templatedetails/:serviceName/:respCode',
    component: TemplateDetailsComponent

  },
  {
    path: 'templatedetails/:serviceName',
    component: TemplateDetailsComponent
  }
];

export const APP_ROUTER_PROVIDER = RouterModule.forRoot(routes, { useHash: false });


// WEBPACK FOOTER //
// ./src/app/app.routes.ts